import React, { Dispatch, SetStateAction, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { CSSTransition } from 'react-transition-group'

import HeaderFilter from "../HeaderFilter";
import FilterItemContent from "../FilterItemContent";
import FooterFilter from "../FooterFilter";
import SendGTAGEvent from "../../utils/sendGTAGEvent";

import { ReactComponent as ArrowDown } from '../../assets/arrow-down.svg'
import { ReactComponent as ArrowUp } from '../../assets/arrow-up.svg'
import { onDisabledScrollHandler, onEnableScrollHandler, windowScreenWidth } from "../../utils/ScrollHandler";

import * as S from "./styles";

interface IFilterState {
    env: string;
    search: string;
    priceRange: number[];
    size: string;
}

interface IFilterModalProps {
    filter: any;
    isOpen: boolean;
    onClose: () => void;
    onClearPage: () => void;
    filterConfigs: {
        shouldHide: boolean;
        filterName: string;
        filterTitle: string;
        filterType: 'radio' | any;
        filterItems?: {
            filterItemName: string;
            filterItemValue: string | number[];
            id?: number;
        }[];
        isOpen: boolean;
    }[]
    setFilter: Dispatch<SetStateAction<IFilterState>>;
    onChangeFilterStatesHandler: (filterKey: string) => void;
    onClearFilter: () => void;
    className: string;
}

const FilterModal: React.FC<IFilterModalProps> = ({
    filter,
    filterConfigs,
    onClearPage,
    isOpen,
    onClose,
    setFilter,
    onChangeFilterStatesHandler,
    onClearFilter,
    className,
}) => {
    const [filterProperties, setfilterProperties] = useState<IFilterState | any>({})
    const [deviceViewport, setDeviceViewport] = useState(false)

    const nodeRef = useRef(null)

    const onClickModalHandler = useCallback(() => {
        onClearPage()
        setFilter(() => ({ ...filterProperties, env: filter.env }))
        onClose()
        SendGTAGEvent(
            'seleciona_filtro',
            'Filtro',
            'Clicou em botão "Ver resultado"',
            `${JSON.stringify(filterProperties)}`
        )
        for (let key in filterProperties) {
            if (key !== 'env') {
                if (Array.isArray(filterProperties[key])) {
                    for (let value of filterProperties[key]) {
                        SendGTAGEvent(
                            `filtro_${key}`,
                            'Filtro',
                            `Clicou no filtro ${key} : ${value}`,
                            ` ${value}`)
                    }
                } else {
                    SendGTAGEvent(
                        `filtro_${key}`,
                        'Filtro',
                        `Clicou no filtro ${key} : ${filterProperties[key]}`,
                        `${filterProperties[key]}`)
                }
            }
        }
    }, [onClearPage, setFilter, onClose, filterProperties, filter.env])

    const onClearFilterProperties = useCallback(() => {
        setfilterProperties(() => ({ env: filter.env }))
    }, [filter.env])

    const onClearAllHandler = useCallback(() => {
        onClearFilter();
        onClearFilterProperties()
        SendGTAGEvent(
            'limpa_filtro',
            'Filtro',
            'Clicou em botão "Limpar Filtros"')
        return setFilter((prevState) => ({ ...prevState, env: prevState?.env, search: prevState.search }))
    }, [onClearFilterProperties, onClearFilter, setFilter])

    const filterContentJsx = useMemo(() => (
        <S.FilterOptions>
            {
                filterConfigs.map((filterConfig) => (

                    <S.Content key={filterConfig.filterName} hidden={filterConfig.shouldHide}>

                        {deviceViewport ?
                            <S.ButtonTitle onClick={() => deviceViewport ? onChangeFilterStatesHandler(filterConfig.filterName) : {}}>
                                <label>{filterConfig.filterTitle}</label>
                                {filterConfig.isOpen && deviceViewport ? <ArrowUp /> : <ArrowDown />}
                            </S.ButtonTitle>
                            :
                            <label>{filterConfig.filterTitle}</label>
                        }

                        <FilterItemContent
                            filterProperties={filterProperties}
                            isOpen={filterConfig.isOpen}
                            filterName={filterConfig.filterName}
                            setfilterProperties={setfilterProperties}
                            filterType={filterConfig.filterType}
                            filterItems={filterConfig.filterItems}
                        />
                    </S.Content>
                ))
            }
        </S.FilterOptions>
    ), [deviceViewport, filterConfigs, filterProperties, onChangeFilterStatesHandler])

    useEffect(() => {
        if (isOpen) {
            onDisabledScrollHandler()
            if (windowScreenWidth()) { setDeviceViewport(true) }
        } else {
            onEnableScrollHandler()
        }
    }, [isOpen])

    return (
        <CSSTransition nodeRef={nodeRef} in={isOpen} timeout={400} classNames="top_bottom_effect" unmountOnExit>
            <S.Container className={className} isOpen={isOpen}>

                <HeaderFilter onClose={onClose} />
                {filterContentJsx}
                <FooterFilter onClickReset={onClearAllHandler} onClickApply={onClickModalHandler} isOpen={isOpen} />

            </S.Container>
        </CSSTransition>
    )
};

export default FilterModal;
